import React from 'react'
import { IconDragHandle, IconOrderAscending, IconOrderDescending } from 'assets'
import { Input } from 'components/shared/Input'
import { getTableCellWidth, isDescending, SortDirection } from 'utilities'
import styles from './TableColHeader.module.scss'
import cl from 'classnames'
import { TableColHeaderProps } from './TableColHeader.types'
import { Select } from 'components/shared/Select'
import { TableSliderFilter } from 'components/shared/TableSliderFilter'
import { TablePeriodFilter } from 'components/shared/TablePeriodFilter'
import {
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot
} from 'react-beautiful-dnd'
import sizes from 'assets/styles/_sizes.scss'
import { Paper } from "@material-ui/core"

const TableColHeaderComponent = (props: TableColHeaderProps) => {
  const {
    label,
    index,
    preset,
    groupLabel,
    groupWidth,
    sortDirection,
    setSortDirection,
    noFilter,
    inputProps,
    selectProps,
    sliderFilterProps,
    periodFilterProps,
    className,
    style = {},
    filterComponent,
    isColumnMarked,
    widthPercentage,
    widthPx,
    widthString,
    draggable,
    bigLabel,
    subHeader,
    disabled
  } = props

  const IconOrder = {
    [SortDirection.ASC]: IconOrderAscending,
    [SortDirection.DESC]: IconOrderDescending
  }[sortDirection]

  const handleChangeSortDirection = () => {
    if (!setSortDirection || disabled) return

    setSortDirection(isColumnMarked
      ? isDescending(sortDirection)
        ? SortDirection.ASC
        : SortDirection.DESC
      : SortDirection.DESC)
  }

  const renderFilterComponent = () => {
    switch (true) {
      case !!inputProps: {
        return (
          <Input {...inputProps} />
        )
      }
      case !!selectProps: {
        return (
          <Select {...selectProps} />
        )
      }
      case !!sliderFilterProps: {
        return (
          <TableSliderFilter {...sliderFilterProps} />
        )
      }
      case !!periodFilterProps: {
        return (
          <TablePeriodFilter {...periodFilterProps} />
        )
      }
      case !!filterComponent: {
        return filterComponent
      }
      default: return null
    }
  }

  const labelStyle = bigLabel ? { paddingBottom: '1px', maxHeight: sizes.rowHeight } : {}

  return (
    <Draggable
      key={label}
      draggableId={label}
      index={index}
      isDragDisabled={!draggable}
    >
      {(provided: DraggableProvided,
        snapshot: DraggableStateSnapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            id={label}
            className={cl(styles.columnHeader, {
              [styles.markedBackground]: isColumnMarked
            }, className)}
            style={{
              ...getTableCellWidth(widthPercentage, widthPx, widthString),
              ...provided.draggableProps.style,
              ...style
            }}
          >
            <p
              className={cl(styles.columnTitle, styles[preset], {
                [styles.clickable]: !disabled && setSortDirection,
                [styles.columnTitleMarked]: isColumnMarked,
                [styles.disabled]: disabled,
                [styles.dragging]: snapshot.isDragging
              })}
              style={{ ...labelStyle }}
              onClick={handleChangeSortDirection}
            >
              {groupLabel && (
                <span
                  className={styles.groupLabel}
                  style={{
                    width: groupWidth
                      ? groupWidth - 2
                      : undefined
                  }}
                >
                  {groupLabel}
                </span>
              )}
              {draggable && (
                <span
                  style={{
                    marginRight: 12.5
                  }}
                  {...(disabled ? {} : provided.dragHandleProps)}
                >
                  <IconDragHandle
                    fill={styles.primary}
                  />
                </span>
              )}
              {label}
              {sortDirection && (
                <span
                  className={cl(styles.iconContainer, {
                    [styles.activeSorting]: !disabled && isColumnMarked
                  })}
                >
                  <IconOrder />
                </span>
              )}
            </p>
            {!noFilter && !snapshot.isDragging && (
              <div
                className={cl(styles.columnFilter, {
                  [styles.columnFilterMarked]: isColumnMarked
                })}
              >
                {renderFilterComponent()}
              </div>
            )}
              {subHeader && <div className={styles.subHeaderContainer}>
               {subHeader.split(",").map(el => <div className={styles.paper}>{el}</div>)}
              </div>}
          </div>
        )
      }}
    </Draggable>
  )
}

const TableColHeader = TableColHeaderComponent
export { TableColHeader }
